import 'custom-event-polyfill';
import React, {PureComponent} from 'react';
import './CookieBanner.scss';
import {TextButton} from '../components/TextButton';
import {ContainedButton} from '../components/ContainedButton';
import {Link} from 'react-static';

function getCookie(sKey) {
    if (!sKey || typeof document === 'undefined') {
        return null;
    }
    return document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + sKey.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1') || null;
}

function setCookie(cookieName, cookieValue) {
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + '=' + cookieValue + '; domain=asbestkrachten.nl; path=/; expires=' + date.toGMTString() + '; secure';
}

export class CookieBanner extends PureComponent {

    state = {
        show: getCookie('consent') !== 'true'
    };

    accept = () => {
        setCookie('consent', 'true');
        this.setState({show: false});
        window.dispatchEvent(new CustomEvent('cookieconsent'));
    };

    reject = () => {
        this.setState({show: false});
    };

    render = () => {
        const {show} = this.state;
        console.log('CookieBanner', show, getCookie('consent'));

        return show ? (
            <div className="cookie-banner cookie-banner--show">
                <div className="cookie-banner--title">
                    Asbestkrachten maakt gebruik van cookies
                </div>

                <div className="cookie-banner--summary">
                    Asbestkrachten gebruikt cookies, JavaScript en vergelijkbare technologie onder andere om u een optimale
                    gebruikerservaring te bieden. Ook kunnen we hierdoor het gedrag van bezoekers vastleggen en
                    analyseren, en deze informatie toevoegen aan bezoekersprofielen.

                    <p><Link to="/cookies">
                        Lees hier meer over cookies.
                    </Link></p>
                </div>

                <div className="cookie-banner--buttons">
                    <ContainedButton onClick={this.accept}>Akkoord</ContainedButton>
                    <TextButton onClick={this.reject}>Niet akkoord</TextButton>
                </div>

                <div className="cookie-banner--overlay"/>
            </div>
        ) : null;
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/sections/CookieBanner.jsx